import axios from 'axios'

const axiosConfig = {
  baseURL: process.env.VUE_APP_API_URL
}

if (
  process.env.VUE_APP_CLOUDFLARE_ACCESS_CLIENT &&
  process.env.VUE_APP_CLOUDFLARE_ACCESS_SECRET
) {
  axiosConfig.headers = {
    'CF-Access-Client-Id': process.env.VUE_APP_CLOUDFLARE_ACCESS_CLIENT,
    'CF-Access-Client-Secret': process.env.VUE_APP_CLOUDFLARE_ACCESS_SECRET
  }
}

const axiosInstance = axios.create(axiosConfig)

export const getCountries = async () => {
  const { data } = await axiosInstance.get(
    `/prestashop/settings/countries/public`
  )
  if (!data.success) {
    throw new Error('Error while fetching countries list')
  }
  return data.countries
}

export const submitForm = async answers => {
  const { data } = await axiosInstance.post(`/prospects`, answers)

  if (!data.success) {
    throw new Error('Error while sumbitting form')
  }

  return data
}

export const searchPotentialSponsors = async prospectId => {
  const { data } = await axiosInstance.get(
    `/prospects/${prospectId}/sponsor/search`
  )
  if (!data.success) {
    throw new Error('Error while fetching Stylists list')
  }
  return data.sponsors
}

export const selectSponsor = async (prospectId, sponsorId) => {
  const { data } = await axiosInstance.post(
    `/prospects/${prospectId}/sponsor/${sponsorId}/select`
  )
  if (!data.success) {
    throw new Error('Error while selecting the sponsor')
  }
  return data.stylist
}

export default {
  getCountries,
  submitForm,
  searchPotentialSponsors,
  selectSponsor
}
